export const YOUR_WEIR_PRODUCTION= 'https://your.weir/'
export const YOUR_WEIR_STAGING= 'https://customer.staging.weir/'
export const YOUR_WEIR_STAGING_MY_ACCOUNT = 'https://customer.staging.weir/myaccount/access'
export const YOUR_WEIR_PRODUCTION_MY_ACCOUNT = 'https://your.weir/myaccount/access'
export const YOUR_WEIR_HUB = 'customer.staging.weir'
